import { render, staticRenderFns } from "./FotoSurvey.vue?vue&type=template&id=d20171c4&scoped=true"
import script from "./FotoSurvey.vue?vue&type=script&lang=js"
export * from "./FotoSurvey.vue?vue&type=script&lang=js"
import style0 from "./FotoSurvey.vue?vue&type=style&index=0&id=d20171c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20171c4",
  null
  
)

export default component.exports